"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var scriptsDone = function scriptsDone() {
  var DOMContentLoadedEvent = document.createEvent("Event");
  DOMContentLoadedEvent.initEvent("DOMContentLoaded", true, true);
  document.dispatchEvent(DOMContentLoadedEvent);
};

var _default = scriptsDone;
exports.default = _default;